import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

export default class extends Controller {
  static targets = ["icon", "spinner", "label"];
  static values = { busyLabel: { type: String, default: "Preparing..." } };

  async download(event) {
    event.preventDefault();
    if (this.busy) return;

    this.start();

    try {
      const response = await get(this.element.href, { responseKind: "binary" });
      if (!response.ok)
        throw new Error(`Export failed: ${response.statusCode}`);
      // An expired session redirects to sign-in, which arrives as a 200 of HTML.
      if (response.contentType === "text/html")
        throw new Error("Signed out during export");

      this.save(await response.response.blob(), response.headers);
    } catch (error) {
      console.error(error);
      window.alert("That export could not be generated. Please try again.");
    } finally {
      this.finish();
    }
  }

  // setAttribute, not `.hidden`: these are SVG elements, where the property does not reflect to the
  // attribute and the element stays visible.
  start() {
    this.busy = true;
    this.element.classList.add("pointer-events-none", "opacity-60");
    this.element.setAttribute("aria-disabled", "true");
    this.iconTarget.setAttribute("hidden", "");
    this.spinnerTarget.removeAttribute("hidden");
    this.originalLabel = this.labelTarget.textContent;
    this.labelTarget.textContent = this.busyLabelValue;
  }

  finish() {
    this.busy = false;
    this.element.classList.remove("pointer-events-none", "opacity-60");
    this.element.removeAttribute("aria-disabled");
    this.iconTarget.removeAttribute("hidden");
    this.spinnerTarget.setAttribute("hidden", "");
    this.labelTarget.textContent = this.originalLabel;
  }

  save(blob, headers) {
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = this.filenameFrom(headers);
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    URL.revokeObjectURL(url);
  }

  filenameFrom(headers) {
    const disposition = headers.get("content-disposition") || "";
    const match = /filename="?([^";]+)"?/.exec(disposition);
    return (match?.[1] || "dashboard-export").trim();
  }
}
